// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SignIn_Signin__GJgkw {
  width: 100%;

  display: flex;

  flex-flow: column;

  justify-content: center;

  margin: auto;

  /* border:1px solid green; */
}

.SignIn_SigninFrom__lffHo {
  width: 340px;

  min-height: 119px;

  margin: auto;

  background-color: #efeeed;

  border: none;

  border-radius: 20px;
}

.SignIn_SigninFrom__lffHo input {
  border: 0;

  background-color: transparent;

  font-size: 18px;
}

.SignIn_SigninFrom__lffHo input:focus {
  outline: none;
  font-family: Arial;
  font-size: 18px;
}

input::placeholder {
  font-size: 14px;

  text-transform: capitalize;

  color: #7a7a7a;

  font-weight: 500;
}
.SignIn_formstyle__\\+tYjU {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.SignIn_SigninFromEmail__ZVRPV {
  width: 86%;

  margin-top: 8%;

  /* margin-left: 10%; */

  border-bottom: 2px solid #a9a8a6;
}

.SignIn_SigninFromPassword__0aL8a {
  width: 86%;

  margin-top: 8%;

  /* margin-left: 10%; */

  border-bottom: 2px solid #a9a8a6;
}

.SignIn_ForgotPassowrd__IB\\+DE {
  margin-top: 4%;

  /* margin-left: 10%; */

  font-size: 14px;

  font-weight: 400;

  color: #4795de;

  cursor: pointer;
}

.SignIn_SigninButton__imwZJ {
  width: 86%;

  margin: 0px 30px 20px 30px;

  padding: 10px 30px;

  /* background-color: #fff; */

  background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%);

  border: none;

  border-radius: 20px;

  color: #fff;

  font-size: 16px;

  font-weight: 300;

  text-transform: capitalize;

  cursor: pointer;

  transition: all 0.2s ease-in-out;
}

.SignIn_SigninButton__imwZJ:disabled {
  background: #f3f2f0;

  color: #7a7a7a;

  cursor: not-allowed;

  opacity: 10;
}

.SignIn_Changesignin__BV26K {
  text-align: center;
  position: relative;
  margin: 10px 0px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.SignIn_Changesignin__BV26K span {
  background: #fff;

  display: inline-block;

  padding: 0 10px;

  position: relative;
}
.SignIn_line__RaCz3 {
  width: 38%;
  height: 1.2px;
  background-color: #7a7a7a;
}

.SignIn_SocailSignIn__8k-GL {
  width: 236px;

  padding: 8px;

  display: flex;

  justify-content: center;

  justify-items: center;

  background-color: #efeeed;

  cursor: pointer;

  border-radius: 20px;

  margin: 0px auto 20px auto;

  text-align: center;
}

.SignIn_SocialImage__lhrMm {
  width: 30px ;
  margin-left: 10px ;
}

.SignIn_ErrorMsg__CkyDW {
  visibility: visible;

  margin: 0px;

  padding: 2px 0 0 0;

  font-size: 12px;

  color: rgb(230, 79, 79);

  text-align: center;
}

.SignIn_StatusMessage__BgNI5 {
  margin: 0px;

  padding-bottom: 10px;

  font-size: 1em;

  color: rgb(230, 79, 79);

  text-align: center;
}

.SignIn_SocialIcon__riDgP {
  display: flex;
  flex-direction: column; /* or column, depending on your layout */
  justify-content: center;
  align-items: center;
}


.SignIn_eyeshowhide__I0O9Y {
  font-size: 1rem !important;
}

.SignIn_textField__8nmY7 {
  width: 100%;
}

/* below is the css of default community  change modal */

.SignIn_defaultCommunityChangeModal__b9c-D{
  display: flex;
  flex-direction: column;
}
.SignIn_defaultCommunityMessageContainer__5hhze{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  width: 100%;
  padding: 5px 5px 15px 15px;
  gap: 10px;

  position: sticky;
  top: 0;       /* stick to top */
  left: 0;      /* start from left */
  right: 0;     /* span full width */
  z-index: 1000; /* keep above other elements */
  box-shadow: 0 2px 6px rgba(0,0,0,0.1); /* optional nice shadow */
}
.SignIn_defaultCommunityMessageContainer__5hhze h5 {
  font-size: 18px;
  font-family: sans-serif;
  color: #373334;
  margin-top: 10px;
}
.SignIn_defaultCommunityMessageContainer__5hhze button {
  background-color: transparent;
  border: none;
  outline: none !important;
  margin-bottom: auto;
  font-size: 20px;
}
.SignIn_defaultCommunityListMainContainer__VwDRo{
  background-color: transparent
}
.SignIn_defaultCommunityListContainer__-Iynm{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 5px;
  padding: 25px 10px 18px 25px;
}
.SignIn_buttonContainer__0XO-Y{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 5px;
}
.SignIn_actions__1SW1C {
  margin-left: 15px;
  height: 25px;            
  width: 25px;            
  padding: 5px;
  display: flex;           
  align-items: center;    
  justify-content: center; 
  border: none;
  border-radius: 40px;
  background: #D3D3D3; /* optional */
  cursor: pointer;
}
.SignIn_actions__1SW1C img {
  height: 12px;
  width: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Landing/components/SignIn/SignIn.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;;EAEX,aAAa;;EAEb,iBAAiB;;EAEjB,uBAAuB;;EAEvB,YAAY;;EAEZ,4BAA4B;AAC9B;;AAEA;EACE,YAAY;;EAEZ,iBAAiB;;EAEjB,YAAY;;EAEZ,yBAAyB;;EAEzB,YAAY;;EAEZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;;EAET,6BAA6B;;EAE7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;;EAEf,0BAA0B;;EAE1B,cAAc;;EAEd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,UAAU;;EAEV,cAAc;;EAEd,sBAAsB;;EAEtB,gCAAgC;AAClC;;AAEA;EACE,UAAU;;EAEV,cAAc;;EAEd,sBAAsB;;EAEtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;;EAEd,sBAAsB;;EAEtB,eAAe;;EAEf,gBAAgB;;EAEhB,cAAc;;EAEd,eAAe;AACjB;;AAEA;EACE,UAAU;;EAEV,0BAA0B;;EAE1B,kBAAkB;;EAElB,4BAA4B;;EAE5B,0EAA0E;;EAE1E,YAAY;;EAEZ,mBAAmB;;EAEnB,WAAW;;EAEX,eAAe;;EAEf,gBAAgB;;EAEhB,0BAA0B;;EAE1B,eAAe;;EAEf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;;EAEnB,cAAc;;EAEd,mBAAmB;;EAEnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;;EAEhB,qBAAqB;;EAErB,eAAe;;EAEf,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;;EAEZ,YAAY;;EAEZ,aAAa;;EAEb,uBAAuB;;EAEvB,qBAAqB;;EAErB,yBAAyB;;EAEzB,eAAe;;EAEf,mBAAmB;;EAEnB,0BAA0B;;EAE1B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;;EAEnB,WAAW;;EAEX,kBAAkB;;EAElB,eAAe;;EAEf,uBAAuB;;EAEvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;;EAEX,oBAAoB;;EAEpB,cAAc;;EAEd,uBAAuB;;EAEvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,wCAAwC;EAChE,uBAAuB;EACvB,mBAAmB;AACrB;;;AAGA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA,wDAAwD;;AAExD;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,SAAS;;EAET,gBAAgB;EAChB,MAAM,QAAQ,iBAAiB;EAC/B,OAAO,OAAO,oBAAoB;EAClC,QAAQ,MAAM,oBAAoB;EAClC,aAAa,EAAE,8BAA8B;EAC7C,qCAAqC,EAAE,yBAAyB;AAClE;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,QAAQ;EACR,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB,EAAE,aAAa;EAClC,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;AACb","sourcesContent":[".Signin {\r\n  width: 100%;\r\n\r\n  display: flex;\r\n\r\n  flex-flow: column;\r\n\r\n  justify-content: center;\r\n\r\n  margin: auto;\r\n\r\n  /* border:1px solid green; */\r\n}\r\n\r\n.SigninFrom {\r\n  width: 340px;\r\n\r\n  min-height: 119px;\r\n\r\n  margin: auto;\r\n\r\n  background-color: #efeeed;\r\n\r\n  border: none;\r\n\r\n  border-radius: 20px;\r\n}\r\n\r\n.SigninFrom input {\r\n  border: 0;\r\n\r\n  background-color: transparent;\r\n\r\n  font-size: 18px;\r\n}\r\n\r\n.SigninFrom input:focus {\r\n  outline: none;\r\n  font-family: Arial;\r\n  font-size: 18px;\r\n}\r\n\r\ninput::placeholder {\r\n  font-size: 14px;\r\n\r\n  text-transform: capitalize;\r\n\r\n  color: #7a7a7a;\r\n\r\n  font-weight: 500;\r\n}\r\n.formstyle {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.SigninFromEmail {\r\n  width: 86%;\r\n\r\n  margin-top: 8%;\r\n\r\n  /* margin-left: 10%; */\r\n\r\n  border-bottom: 2px solid #a9a8a6;\r\n}\r\n\r\n.SigninFromPassword {\r\n  width: 86%;\r\n\r\n  margin-top: 8%;\r\n\r\n  /* margin-left: 10%; */\r\n\r\n  border-bottom: 2px solid #a9a8a6;\r\n}\r\n\r\n.ForgotPassowrd {\r\n  margin-top: 4%;\r\n\r\n  /* margin-left: 10%; */\r\n\r\n  font-size: 14px;\r\n\r\n  font-weight: 400;\r\n\r\n  color: #4795de;\r\n\r\n  cursor: pointer;\r\n}\r\n\r\n.SigninButton {\r\n  width: 86%;\r\n\r\n  margin: 0px 30px 20px 30px;\r\n\r\n  padding: 10px 30px;\r\n\r\n  /* background-color: #fff; */\r\n\r\n  background: linear-gradient(123deg, #6ca8e1 0%, #4795de 49%, #0071dd 100%);\r\n\r\n  border: none;\r\n\r\n  border-radius: 20px;\r\n\r\n  color: #fff;\r\n\r\n  font-size: 16px;\r\n\r\n  font-weight: 300;\r\n\r\n  text-transform: capitalize;\r\n\r\n  cursor: pointer;\r\n\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.SigninButton:disabled {\r\n  background: #f3f2f0;\r\n\r\n  color: #7a7a7a;\r\n\r\n  cursor: not-allowed;\r\n\r\n  opacity: 10;\r\n}\r\n\r\n.Changesignin {\r\n  text-align: center;\r\n  position: relative;\r\n  margin: 10px 0px;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.Changesignin span {\r\n  background: #fff;\r\n\r\n  display: inline-block;\r\n\r\n  padding: 0 10px;\r\n\r\n  position: relative;\r\n}\r\n.line {\r\n  width: 38%;\r\n  height: 1.2px;\r\n  background-color: #7a7a7a;\r\n}\r\n\r\n.SocailSignIn {\r\n  width: 236px;\r\n\r\n  padding: 8px;\r\n\r\n  display: flex;\r\n\r\n  justify-content: center;\r\n\r\n  justify-items: center;\r\n\r\n  background-color: #efeeed;\r\n\r\n  cursor: pointer;\r\n\r\n  border-radius: 20px;\r\n\r\n  margin: 0px auto 20px auto;\r\n\r\n  text-align: center;\r\n}\r\n\r\n.SocialImage {\r\n  width: 30px ;\r\n  margin-left: 10px ;\r\n}\r\n\r\n.ErrorMsg {\r\n  visibility: visible;\r\n\r\n  margin: 0px;\r\n\r\n  padding: 2px 0 0 0;\r\n\r\n  font-size: 12px;\r\n\r\n  color: rgb(230, 79, 79);\r\n\r\n  text-align: center;\r\n}\r\n\r\n.StatusMessage {\r\n  margin: 0px;\r\n\r\n  padding-bottom: 10px;\r\n\r\n  font-size: 1em;\r\n\r\n  color: rgb(230, 79, 79);\r\n\r\n  text-align: center;\r\n}\r\n\r\n.SocialIcon {\r\n  display: flex;\r\n  flex-direction: column; /* or column, depending on your layout */\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n\r\n.eyeshowhide {\r\n  font-size: 1rem !important;\r\n}\r\n\r\n.textField {\r\n  width: 100%;\r\n}\r\n\r\n/* below is the css of default community  change modal */\r\n\r\n.defaultCommunityChangeModal{\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n.defaultCommunityMessageContainer{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: #fff;\r\n  width: 100%;\r\n  padding: 5px 5px 15px 15px;\r\n  gap: 10px;\r\n\r\n  position: sticky;\r\n  top: 0;       /* stick to top */\r\n  left: 0;      /* start from left */\r\n  right: 0;     /* span full width */\r\n  z-index: 1000; /* keep above other elements */\r\n  box-shadow: 0 2px 6px rgba(0,0,0,0.1); /* optional nice shadow */\r\n}\r\n.defaultCommunityMessageContainer h5 {\r\n  font-size: 18px;\r\n  font-family: sans-serif;\r\n  color: #373334;\r\n  margin-top: 10px;\r\n}\r\n.defaultCommunityMessageContainer button {\r\n  background-color: transparent;\r\n  border: none;\r\n  outline: none !important;\r\n  margin-bottom: auto;\r\n  font-size: 20px;\r\n}\r\n.defaultCommunityListMainContainer{\r\n  background-color: transparent\r\n}\r\n.defaultCommunityListContainer{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n  gap: 5px;\r\n  padding: 25px 10px 18px 25px;\r\n}\r\n.buttonContainer{\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  margin-top: 5px;\r\n}\r\n.actions {\r\n  margin-left: 15px;\r\n  height: 25px;            \r\n  width: 25px;            \r\n  padding: 5px;\r\n  display: flex;           \r\n  align-items: center;    \r\n  justify-content: center; \r\n  border: none;\r\n  border-radius: 40px;\r\n  background: #D3D3D3; /* optional */\r\n  cursor: pointer;\r\n}\r\n.actions img {\r\n  height: 12px;\r\n  width: 12px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Signin": `SignIn_Signin__GJgkw`,
	"SigninFrom": `SignIn_SigninFrom__lffHo`,
	"formstyle": `SignIn_formstyle__+tYjU`,
	"SigninFromEmail": `SignIn_SigninFromEmail__ZVRPV`,
	"SigninFromPassword": `SignIn_SigninFromPassword__0aL8a`,
	"ForgotPassowrd": `SignIn_ForgotPassowrd__IB+DE`,
	"SigninButton": `SignIn_SigninButton__imwZJ`,
	"Changesignin": `SignIn_Changesignin__BV26K`,
	"line": `SignIn_line__RaCz3`,
	"SocailSignIn": `SignIn_SocailSignIn__8k-GL`,
	"SocialImage": `SignIn_SocialImage__lhrMm`,
	"ErrorMsg": `SignIn_ErrorMsg__CkyDW`,
	"StatusMessage": `SignIn_StatusMessage__BgNI5`,
	"SocialIcon": `SignIn_SocialIcon__riDgP`,
	"eyeshowhide": `SignIn_eyeshowhide__I0O9Y`,
	"textField": `SignIn_textField__8nmY7`,
	"defaultCommunityChangeModal": `SignIn_defaultCommunityChangeModal__b9c-D`,
	"defaultCommunityMessageContainer": `SignIn_defaultCommunityMessageContainer__5hhze`,
	"defaultCommunityListMainContainer": `SignIn_defaultCommunityListMainContainer__VwDRo`,
	"defaultCommunityListContainer": `SignIn_defaultCommunityListContainer__-Iynm`,
	"buttonContainer": `SignIn_buttonContainer__0XO-Y`,
	"actions": `SignIn_actions__1SW1C`
};
export default ___CSS_LOADER_EXPORT___;
